/**
 * Created by renjie.huang on 2017/10/11.
 */

var urls;
var ucloudRootDomain = 'ucloud.cn';

var url_config = {
	'ucloud.cn': {
		root: 'ucloud.cn',
		url: 'https://api.ucloud.cn',
		default: 'https://console.ucloud.cn',
		dws: 'https://dws.ucloud.cn',
		whiteList: [ /\.ucloud.cn/ ],
		afterLogout : 'https://www.ucloud.cn',
		authUrl : 'https://accountv2.ucloud.cn/authentication'
	},
	// 专属云 test03 环境 668
	'passport.test03.ucdctest.com': {
		root: 'test03.ucdctest.com',
		url: 'https://api.test03.ucdctest.com',
		default: 'https://console.test03.ucdctest.com',
		dws: 'https://dws.test03.ucdctest.com',
		whiteList: [ /\.test03.ucdctest.com/ ],
		afterLogout : 'https://passport.test03.ucdctest.com',
		authUrl : 'https://console.test03.ucdctest.com/uaccount/authentication'
	},
	// 专属云 test03 环境 670
	'passport.cdcv2-test.cosmos-intl.com': {
		root: 'cdcv2-test.cosmos-intl.com',
		url: 'https://api.cdcv2-test.cosmos-intl.com',
		default: 'https://console.cdcv2-test.cosmos-intl.com',
		dws: 'https://dws.cdcv2-test.cosmos-intl.com',
		whiteList: [ /\.cdcv2-test.cosmos-intl.com/ ],
		afterLogout : 'https://passport.cdcv2-test.cosmos-intl.com',
		authUrl : 'https://console.cdcv2-test.cosmos-intl.com/uaccount/authentication'
	},
	'ipv6-passport.ucloud.cn': {
		root: 'ucloud.cn',
		url: 'https://api.ucloud.cn',
		default: 'https://ipv6-console.ucloud.cn',
		dws: 'https://dws.ucloud.cn',
		whiteList: [ /\.ucloud.cn/ ],
		afterLogout : 'https://ipv6.ucloud.cn',
		authUrl : 'https://ipv6-accountv2.ucloud.cn/authentication'
	},
	'pre.ucloudadmin.com': {
		root: 'pre.ucloudadmin.com',
		url: 'https://api.pre.ucloudadmin.com',
		default: 'https://newconsole-pre.pre.ucloudadmin.com',
		dws: 'https://dws.pre.ucloudadmin.com',
		whiteList: [ /\.ucloudadmin.com/ ],
		afterLogout : 'https://www.ucloud.cn',
		authUrl : 'https://accountv2.pre.ucloudadmin.com/authentication'
	},
	'passport-pre2.pre.ucloudadmin.com': {
		root: 'pre.ucloudadmin.com',
		url: 'https://api-pre2.pre.ucloudadmin.com',
		default: 'https://console-pre2.pre.ucloudadmin.com',
		dws: 'https://dws-pre2.pre.ucloudadmin.com',
		whiteList: [ /\.pre.ucloudadmin.com/ ],
		afterLogout : 'https://wwww.ucloud.cn',
		authUrl : 'https://account-pre2.pre.ucloudadmin.com/authentication'
	},
	'passport.ucloudadmin.com': {
		root: 'ucloudadmin.com',
		url: 'https://api-inner.ucloudadmin.com',
		default: 'https://console.ucloudadmin.com',
		dws: 'https://dws.ucloudadmin.com',
		whiteList: [ /\.ucloudadmin.com/ ],
		afterLogout : 'https://www.ucloud.cn',
		authUrl : 'https://account.ucloudadmin.com/authentication'
	},
	//浪潮
	'cloud.inspur.com': {
		root: 'cloud.inspur.com',
		url: 'https://api.cloud.inspur.com',
		default: 'https://consolev4.cloud.inspur.com',
		dws: 'https://dws.cloud.inspur.com',
		whiteList: [ /\.cloud.inspur.com/ ],
		afterLogout : 'https://cloud.inspur.com',
		authUrl : 'https://cloud.inspur.com/certify.certification.dhtml'
	},
	//教育云
	'passport-edu.ucloud.cn': {
		root: 'ucloud.cn',
		url: 'https://api-edu.ucloud.cn',
		default: 'https://console-edu.ucloud.cn',
		dws: 'https://dws-edu.ucloud.cn',
		whiteList: [ /\.ucloud.cn/ ],
		afterLogout : 'https://edu.ucloud.cn',
		authUrl : 'https://account-edu.ucloud.cn/authentication'
	},
	//中通服
	'ztfgzcps.com': {
		root: 'ztfgzcps.com',
		url: 'https://api.ztfgzcps.com',
		default: 'https://console.ztfgzcps.com',
		dws: 'https://dws.ztfgzcps.com',
		whiteList: [ /\.ztfgzcps.com/ ],
		afterLogout : 'https://console.ztfgzcps.com',
		authUrl : 'https://account.ztfgzcps.com/authentication'
	},
	//demo
	'passport-demo.ucloud.cn': {
		root: 'ucloud.cn',
		url: 'https://api-demo.ucloud.cn',
		default: 'https://console-demo.ucloud.cn',
		dws: 'https://dws-demo.ucloud.cn',
		whiteList: [ /\.ucloud.cn/ ],
		afterLogout : 'https://passport-demo.ucloud.cn',
		authUrl : 'https://account-demo.ucloud.cn/authentication'
	},
	//富士康
	'passport-fii.ucloud.cn': {
		root: 'ucloud.cn',
		url: 'https://api-fii.ucloud.cn',
		default: 'https://console-fii.ucloud.cn',
		dws: 'https://dws-fii.ucloud.cn',
		whiteList: [ /\.ucloud.cn/ ],
		afterLogout : 'https://fii.ucloud.cn',
		authUrl : 'https://account-fii.ucloud.cn/authentication'
	},
	//上海移动
	'passport-10086.ucloud.cn': {
		root: 'ucloud.cn',
		url: 'https://api-10086.ucloud.cn',
		default: 'https://console-10086.ucloud.cn',
		dws: 'https://dws-10086.ucloud.cn',
		whiteList: [ /\.ucloud.cn/ ],
		afterLogout : 'https://passport-10086.ucloud.cn',
		authUrl : 'https://account-10086.ucloud.cn/authentication'
	},
	'ipv6-passport-10086.ucloud.cn': {
		root: 'ucloud.cn',
		url: 'https://api-10086.ucloud.cn',
		default: 'https://ipv6-console-10086.ucloud.cn',
		dws: 'https://dws-10086.ucloud.cn',
		whiteList: [ /\.ucloud.cn/ ],
		afterLogout : 'https://ipv6-passport-10086.ucloud.cn',
		authUrl : 'https://ipv6-account-10086.ucloud.cn/authentication'
	},
	//明合
	'passport-minghe.ucloud.cn': {
		root: 'ucloud.cn',
		url: 'https://api-minghe.ucloud.cn',
		default: 'https://console-minghe.ucloud.cn',
		dws: 'https://dws-minghe.ucloud.cn',
		whiteList: [ /\.ucloud.cn/ ],
		afterLogout : 'https://minghe.ucloud.cn',
		authUrl : 'https://account-minghe.ucloud.cn/authentication'
	},
	//中移
	'passport-cmccit.ucloud.cn': {
		root: 'ucloud.cn',
		url: 'https://api-cmccit.ucloud.cn',
		default: 'https://console-cmccit.ucloud.cn',
		dws: 'https://dws-cmccit.ucloud.cn',
		whiteList: [ /\.ucloud.cn/ ],
		afterLogout : 'https://passport-cmccit.ucloud.cn',
		authUrl : 'https://account-cmccit.ucloud.cn/authentication'
	},
	//云知声
	'passport.auto-ai.com.cn': {
		root: 'auto-ai.com.cn',
		url: 'https://api.auto-ai.com.cn',
		default: 'https://console.auto-ai.com.cn',
		dws: 'https://dws.auto-ai.com.cn',
		whiteList: [ /\.auto-ai.com.cn/ ],
		afterLogout : 'https://console.auto-ai.com.cn',
		authUrl : 'https://account.auto-ai.com.cn/authentication'
	},
	//HN06机房, upc-poc.cn
	'passport.upc-poc.cn': {
		root: 'upc-poc.cn',
		url: 'https://api.upc-poc.cn',
		default: 'https://console.upc-poc.cn',
		dws: 'https://dws.upc-poc.cn',
		whiteList: [ /\.upc-poc.cn/ ],
		afterLogout : 'https://console.upc-poc.cn',
		authUrl : 'https://account.upc-poc.cn/authentication'
	},
	// 中航信
	'passport.travelskycloud.com': {
		root: 'travelskycloud.com',
		url: 'https://api.travelskycloud.com',
		default: 'https://console.travelskycloud.com',
		dws: 'https://dws.travelskycloud.com',
		whiteList: [ /\.travelskycloud.com/ ],
		afterLogout : 'https://passport.travelskycloud.com',
		authUrl : 'https://account.travelskycloud.com/authentication'
	},
	// XY兴业专有云
	'passport.cloudx.cibfintech.com': {
		root: 'cloudx.cibfintech.com',
		url: 'https://api.cloudx.cibfintech.com',
		default: 'https://console.cloudx.cibfintech.com',
		dws: 'https://dws.cloudx.cibfintech.com',
		whiteList: [ /\.cloudx.cibfintech.com/ ],
		afterLogout : 'https://passport.cloudx.cibfintech.com',
		authUrl : 'https://account.cloudx.cibfintech.com/authentication'
	},
	// 联云易通
	'passport.dxconsole.com': {
		root: 'dxconsole.com',
		url: 'https://api.dxconsole.com',
		default: 'https://console.dxconsole.com',
		dws: 'https://dws.dxconsole.com',
		whiteList: [ /\.dxconsole.com/ ],
		afterLogout : 'https://passport.dxconsole.com',
		authUrl : 'https://account.dxconsole.com/authentication'
	},
	// 赛尔教育云
	'passport.cercloud.net': {
		root: 'cercloud.net',
		url: 'https://api.cercloud.net',
		default: 'https://console.cercloud.net',
		dws: 'https://dws.cercloud.net',
		whiteList: [ /\.cercloud.net/ ],
		afterLogout : 'https://passport.cercloud.net',
		authUrl : 'https://account.cercloud.net/authentication'
	},
	// 中移物联网
	'passport.iot-10086.ucloud.cn': {
		root: 'iot-10086.ucloud.cn',
		url: 'https://api.iot-10086.ucloud.cn',
		default: 'https://console.iot-10086.ucloud.cn',
		dws: 'https://dws.iot-10086.ucloud.cn',
		whiteList: [ /\.iot-10086.ucloud.cn/ ],
		afterLogout : 'https://passport.iot-10086.ucloud.cn',
		authUrl : 'https://account.iot-10086.ucloud.cn/authentication'
	},
	// 广州移动
	'passport.ecloud-gdu.com': {
		root: 'ecloud-gdu.com',
		url: 'https://api.ecloud-gdu.com',
		default: 'https://console.ecloud-gdu.com',
		dws: 'https://dws.ecloud-gdu.com',
		whiteList: [ /\.ecloud-gdu.com/ ],
		afterLogout : 'https://passport.ecloud-gdu.com',
		authUrl : 'https://account.ecloud-gdu.com/authentication'
	},
	// 新加坡
	'passport.scloud.sg': {
		root: 'scloud.sg',
		url: 'https://api.scloud.sg',
		default: 'https://console.scloud.sg',
		dws: 'https://dws.scloud.sg',
		whiteList: [ /\.scloud.sg/ ],
		afterLogout : 'https://passport.scloud.sg',
		authUrl : 'https://account.scloud.sg/authentication'
	},
	// 艾速科技
	'passport.cdnspeed.cn': {
		root: 'cdnspeed.cn',
		url: 'https://api.cdnspeed.cn',
		default: 'https://console.cdnspeed.cn',
		dws: 'https://dws.cdnspeed.cn',
		whiteList: [ /\.cdnspeed.cn/ ],
		afterLogout : 'https://passport.cdnspeed.cn',
		authUrl : 'https://account.cdnspeed.cn/authentication'
	},
	//测试
	'passport-channel.pre.ucloudadmin.com': {
		root: 'ucloudadmin.com',
		url: 'https://api-test.pre.ucloudadmin.com',
		default: 'https://newconsole-test-pre.pre.ucloudadmin.com',
		dws: 'https://dws.pre.ucloudadmin.com',
		whiteList: [ /\.ucloudadmin.com/ ],
		afterLogout : 'https://www.ucloud.cn',
		authUrl : 'https://accountv2.pre.ucloudadmin.com/authentication'
	},
	// test03
	'passport-test03.ucloudadmin.com': {
		root: 'ucloudadmin.com',
		url: 'https://api-test03.ucloudadmin.com',
		default: 'https://console-test03.ucloudadmin.com',
		dws: 'https://dws-test03.ucloudadmin.com',
		whiteList: [ /\.ucloudadmin.com/ ],
		afterLogout : 'https://passport-test03.ucloudadmin.com',
		authUrl : 'https://console-test03.ucloudadmin.com/uaccount/authentication'
	},
	// 华数云
	'passport-cloudwasu.ucloud.cn': {
		root: 'ucloud.cn',
		url: 'https://api-cloudwasu.ucloud.cn',
		default: 'https://console-cloudwasu.ucloud.cn',
		dws: 'https://dws-cloudwasu.ucloud.cn',
		whiteList: [ /\.ucloud.cn/ ],
		afterLogout : 'https://passport-cloudwasu.ucloud.cn',
		authUrl : 'https://console-cloudwasu.ucloud.cn/uaccount/authentication'
	},
	// 轻量算力平台
	'passport.compshare.cn': {
		root: 'compshare.cn',
		url: 'https://api.compshare.cn',
		default: 'https://console.compshare.cn',
		dws: 'https://dws.compshare.cn',
		whiteList: [ /\.compshare.cn/ ],
		afterLogout : 'https://passport.compshare.cn',
		authUrl : 'https://console.compshare.cn/uaccount/authentication'
	},
	// ucloud-glboal.com 126 海外
	'passport.ucloud-global.com': {
		root: 'ucloud-global.com',
		url: 'https://api.ucloud-global.com',
		default: 'https://console.ucloud-global.com',
		dws: 'https://dws.ucloud-global.com',
		whiteList: [ /\.ucloud-global.com/ ],
		afterLogout : 'https://passport.ucloud-global.com',
		authUrl : 'https://console.ucloud-global.com/uaccount/authentication'
	},
	// ucdctest.com 127 专属云
	'passport.ucdctest.com': {
		root: 'ucdctest.com',
		url: 'https://api.ucdctest.com',
		default: 'https://console.ucdctest.com',
		dws: 'https://dws.ucdctest.com',
		whiteList: [ /\.ucdctest.com/ ],
		afterLogout : 'https://passport.ucdctest.com',
		authUrl : 'https://console.ucdctest.com/uaccount/authentication'
	},
	// surfercloud.com
	'passport.surfercloud.com': {
		root: 'surfercloud.com',
		url: 'https://api.surfercloud.com',
		default: 'https://console.surfercloud.com',
		dws: 'https://dws.surfercloud.com',
		whiteList: [ /\.surfercloud.com/ ],
		afterLogout : 'https://passport.surfercloud.com',
		authUrl : 'https://console.surfercloud.com/uaccount/authentication'
	},
	// -xcloud.xincache.cn
	'passport-xcloud.xincache.cn': {
		root: 'xincache.cn',
		url: 'https://api-xcloud.xincache.cn',
		default: 'https://console-xcloud.xincache.cn',
		dws: 'https://dws-xcloud.xincache.cn',
		whiteList: [ /\.xincache.cn/ ],
		afterLogout : 'https://passport-xcloud.xincache.cn',
		authUrl : 'https://console-xcloud.xincache.cn/uaccount/authentication'
	},
	// 云汉专属云体验 130
	'passport.cosmos-ucloud.com.cn': {
		root: 'cosmos-ucloud.com.cn',
		url: 'https://api.cosmos-ucloud.com.cn',
		default: 'https://console.cosmos-ucloud.com.cn',
		dws: 'https://dws.cosmos-ucloud.com.cn',
		whiteList: [ /\.cosmos-ucloud.com.cn/ ],
		afterLogout : 'https://passport.cosmos-ucloud.com.cn',
		authUrl : 'https://console.cosmos-ucloud.com.cn/uaccount/authentication'
	},
	// 点动科技 132
	'passport.cloud.dd1010.com': {
		root: 'cloud.dd1010.com',
		url: 'https://api.cloud.dd1010.com',
		default: 'https://console.cloud.dd1010.com',
		dws: 'https://dws.cloud.dd1010.com',
		whiteList: [ /\.cloud.dd1010.com/ ],
		afterLogout : 'https://passport.cloud.dd1010.com',
		authUrl : 'https://console.cloud.dd1010.com/uaccount/authentication'
	},
	// 海外专属云测试 133
	'passport.ucdctest-intl.com': {
		root: 'ucdctest-intl.com',
		url: 'https://api.ucdctest-intl.com',
		default: 'https://console.ucdctest-intl.com',
		dws: 'https://dws.ucdctest-intl.com',
		whiteList: [ /\.ucdctest-intl.com/ ],
		afterLogout : 'https://passport.ucdctest-intl.com',
		authUrl : 'https://console.ucdctest-intl.com/uaccount/authentication'
	},
	// 北京蛛蛛 135
	'passport.bjzzxxjs.com': {
		root: 'bjzzxxjs.com',
		url: 'https://api.bjzzxxjs.com',
		default: 'https://console.bjzzxxjs.com',
		dws: 'https://dws.bjzzxxjs.com',
		whiteList: [ /\.bjzzxxjs.com/ ],
		afterLogout : 'https://passport.bjzzxxjs.com',
		authUrl : 'https://console.bjzzxxjs.com/uaccount/authentication'
	},
	// 算丰 136
	'passport.usuanova.com': {
		root: 'usuanova.com',
		url: 'https://api.usuanova.com',
		default: 'https://console.usuanova.com',
		dws: 'https://dws.usuanova.com',
		whiteList: [ /\.usuanova.com/ ],
		afterLogout : 'https://passport.usuanova.com',
		authUrl : 'https://console.usuanova.com/uaccount/authentication'
	},
	// sigcalcloud 137
	'passport.sigcalcloud.com': {
		root: 'sigcalcloud.com',
		url: 'https://api.sigcalcloud.com',
		default: 'https://console.sigcalcloud.com',
		dws: 'https://dws.sigcalcloud.com',
		whiteList: [ /\.sigcalcloud.com/ ],
		afterLogout : 'https://passport.sigcalcloud.com',
		authUrl : 'https://console.sigcalcloud.com/uaccount/authentication'
	},
	// 专属云 scloud 134
	'passport.altusclouds.com': {
		root: 'altusclouds.com',
		url: 'https://api.altusclouds.com',
		default: 'https://console.altusclouds.com',
		dws: 'https://dws.altusclouds.com',
		whiteList: [ /\.altusclouds.com/ ],
		afterLogout : 'https://passport.altusclouds.com',
		authUrl : 'https://console.altusclouds.com/uaccount/authentication'
	},
	// 	138
	'passport.lichenscloud.top': {
		root: 'lichenscloud.top',
		url: 'https://api.lichenscloud.top',
		default: 'https://console.lichenscloud.top',
		dws: 'https://dws.lichenscloud.top',
		whiteList: [ /\.lichenscloud.top/ ],
		afterLogout : 'https://passport.lichenscloud.top',
		authUrl : 'https://console.lichenscloud.top/uaccount/authentication'
	},
	// 	互盟科技 140
	'passport.humeng.cn': {
		root: 'humeng.cn',
		url: 'https://api.humeng.cn',
		default: 'https://console.humeng.cn',
		dws: 'https://dws.humeng.cn',
		whiteList: [ /\.humeng.cn/ ],
		afterLogout : 'https://passport.humeng.cn',
		authUrl : 'https://console.humeng.cn/uaccount/authentication'
	},
	// 香港算丰
	'passport.isuanova.com': {
		root: 'isuanova.com',
		url: 'https://api.isuanova.com',
		default: 'https://console.isuanova.com',
		dws: 'https://dws.isuanova.com',
		whiteList: [ /\.isuanova.com/ ],
		afterLogout : 'https://passport.isuanova.com',
		authUrl : 'https://console.isuanova.com/uaccount/authentication'
	},
	// HGC
	'passport.nubexcloud.com': {
		root: 'nubexcloud.com',
		url: 'https://api.nubexcloud.com',
		default: 'https://console.nubexcloud.com',
		dws: 'https://dws.nubexcloud.com',
		whiteList: [ /\.nubexcloud.com/ ],
		afterLogout : 'https://passport.nubexcloud.com',
		authUrl : 'https://console.nubexcloud.com/uaccount/authentication'
	},
	// bulaoke.com
	'passport.bulaoke.com': {
		root: 'bulaoke.com',
		url: 'https://api.bulaoke.com',
		default: 'https://console.bulaoke.com',
		dws: 'https://dws.bulaoke.com',
		whiteList: [ /\.bulaoke.com/ ],
		afterLogout : 'https://passport.bulaoke.com',
		authUrl : 'https://console.bulaoke.com/uaccount/authentication'
	},
	// tnqacloud.com
	'passport.tnqacloud.com': {
		root: 'tnqacloud.com',
		url: 'https://api.tnqacloud.com',
		default: 'https://console.tnqacloud.com',
		dws: 'https://dws.tnqacloud.com',
		whiteList: [ /\.tnqacloud.com/ ],
		afterLogout : 'https://passport.tnqacloud.com',
		authUrl : 'https://console.tnqacloud.com/uaccount/authentication'
	},
	// hxvps.cn
	'passport.hxvps.cn': {
		root: 'hxvps.cn',
		url: 'https://api.hxvps.cn',
		default: 'https://console.hxvps.cn',
		dws: 'https://dws.hxvps.cn',
		whiteList: [ /\.hxvps.cn/ ],
		afterLogout : 'https://passport.hxvps.cn',
		authUrl : 'https://console.hxvps.cn/uaccount/authentication'
	},
	// dezai.com
	'passport.dezai.com': {
		root: 'dezai.com',
		url: 'https://apiucloud.dezai.com',
		default: 'https://console.dezai.com',
		dws: 'https://dws.dezai.com',
		whiteList: [ /\.dezai.com/ ],
		afterLogout : 'https://passport.dezai.com',
		authUrl : 'https://console.dezai.com/uaccount/authentication'
	},
	// yhypay.com
	'passport.yhypay.com': {
		root: 'yhypay.com',
		url: 'https://api.yhypay.com',
		default: 'https://console.yhypay.com',
		dws: 'https://dws.yhypay.com',
		whiteList: [ /\.yhypay.com/ ],
		afterLogout : 'https://passport.yhypay.com',
		authUrl : 'https://console.yhypay.com/uaccount/authentication'
	},
	// zosoc.com
	'passport.zosoc.com': {
		root: 'zosoc.com',
		url: 'https://api.zosoc.com',
		default: 'https://console.zosoc.com',
		dws: 'https://dws.zosoc.com',
		whiteList: [ /\.zosoc.com/ ],
		afterLogout : 'https://passport.zosoc.com',
		authUrl : 'https://console.zosoc.com/uaccount/authentication'
	},
	// 151
	'passport.cdcv2-intl.cosmos-intl.com': {
		root: 'cdcv2-intl.cosmos-intl.com',
		url: 'https://api.cdcv2-intl.cosmos-intl.com',
		default: 'https://console.cdcv2-intl.cosmos-intl.com',
		dws: 'https://dws.cdcv2-intl.cosmos-intl.com',
		whiteList: [ /\.cdcv2-intl.cosmos-intl.com/ ],
		afterLogout : 'https://passport.cdcv2-intl.cosmos-intl.com',
		authUrl : 'https://console.cdcv2-intl.cosmos-intl.com/uaccount/authentication'
	},
	// 152
	'passport.cdcv2-cn.cosmos-intl.com': {
		root: 'cdcv2-cn.cosmos-intl.com',
		url: 'https://api.cdcv2-cn.cosmos-intl.com',
		default: 'https://console.cdcv2-cn.cosmos-intl.com',
		dws: 'https://dws.cdcv2-cn.cosmos-intl.com',
		whiteList: [ /\.cdcv2-cn.cosmos-intl.com/ ],
		afterLogout : 'https://passport.cdcv2-cn.cosmos-intl.com',
		authUrl : 'https://console.cdcv2-cn.cosmos-intl.com/uaccount/authentication'
	},
	// 154
	'passport.netlake.cn': {
		root: 'netlake.cn',
		url: 'https://api.netlake.cn',
		default: 'https://console.netlake.cn',
		dws: 'https://dws.netlake.cn',
		whiteList: [ /\.netlake.cn/ ],
		afterLogout : 'https://passport.netlake.cn',
		authUrl : 'https://console.netlake.cn/uaccount/authentication'
	},
	// 156
	'passport.idc518.cn': {
		root: 'idc518.cn',
		url: 'https://api.idc518.cn',
		default: 'https://console.idc518.cn',
		dws: 'https://dws.idc518.cn',
		whiteList: [ /\.idc518.cn/ ],
		afterLogout : 'https://passport.idc518.cn',
		authUrl : 'https://console.idc518.cn/uaccount/authentication'
	},
	// 157
	'passport.e2cs.com': {
		root: 'e2cs.com',
		url: 'https://api.e2cs.com',
		default: 'https://console.e2cs.com',
		dws: 'https://dws.e2cs.com',
		whiteList: [ /\.e2cs.com/ ],
		afterLogout : 'https://passport.e2cs.com',
		authUrl : 'https://console.e2cs.com/uaccount/authentication'
	},
	// 158
	'passport.x-adc.cn': {
		root: 'x-adc.cn',
		url: 'https://api.x-adc.cn',
		default: 'https://console.x-adc.cn',
		dws: 'https://dws.x-adc.cn',
		whiteList: [ /\.x-adc.cn/ ],
		afterLogout : 'https://passport.x-adc.cn',
		authUrl : 'https://console.x-adc.cn/uaccount/authentication'
	},
	// 159
	'passport.genesissai.com': {
		root: 'genesissai.com',
		url: 'https://api.genesissai.com',
		default: 'https://console.genesissai.com',
		dws: 'https://dws.genesissai.com',
		whiteList: [ /\.genesissai.com/ ],
		afterLogout : 'https://passport.genesissai.com',
		authUrl : 'https://console.genesissai.com/uaccount/authentication'
	},
	// 160
	'passport.lifangyun.com': {
		root: 'lifangyun.com',
		url: 'https://api.lifangyun.com',
		default: 'https://console.lifangyun.com',
		dws: 'https://dws.lifangyun.com',
		whiteList: [ /\.lifangyun.com/ ],
		afterLogout : 'https://passport.lifangyun.com',
		authUrl : 'https://console.lifangyun.com/uaccount/authentication'
	},
	// 161
	'passport-ajyun.cachecenter.com': {
		root: 'cachecenter.com',
		url: 'https://api-ajyun.cachecenter.com',
		default: 'https://console-ajyun.cachecenter.com',
		dws: 'https://dws-ajyun.cachecenter.com',
		whiteList: [ /\.cachecenter.com/ ],
		afterLogout : 'https://passport-ajyun.cachecenter.com',
		authUrl : 'https://console-ajyun.cachecenter.com/uaccount/authentication'
	},
	// 162
	'passport.matecloud.ai': {
		root: 'matecloud.ai',
		url: 'https://api.matecloud.ai',
		default: 'https://console.matecloud.ai',
		dws: 'https://dws.matecloud.ai',
		whiteList: [ /\.matecloud.ai/ ],
		afterLogout : 'https://passport.matecloud.ai',
		authUrl : 'https://console.matecloud.ai/uaccount/authentication'
	},
	// 162
	'passport.taihuyun.cn': {
		root: 'taihuyun.cn',
		url: 'https://api.taihuyun.cn',
		default: 'https://console.taihuyun.cn',
		dws: 'https://dws.taihuyun.cn',
		whiteList: [ /\.taihuyun.cn/ ],
		afterLogout : 'https://passport.taihuyun.cn',
		authUrl : 'https://console.taihuyun.cn/uaccount/authentication'
	},
	// 164
	'passport.an-link.com': {
		root: 'an-link.com',
		url: 'https://api.an-link.com',
		default: 'https://console.an-link.com',
		dws: 'https://dws.an-link.com',
		whiteList: [ /\.an-link.com/ ],
		afterLogout : 'https://passport.an-link.com',
		authUrl : 'https://console.an-link.com/uaccount/authentication'
	},
	// 149
	'passport.scloudsg.com': {
		root: 'scloudsg.com',
		url: 'https://api.scloudsg.com',
		default: 'https://console.scloudsg.com',
		dws: 'https://dws.scloudsg.com',
		whiteList: [ /\.scloudsg.com/ ],
		afterLogout : 'https://passport.scloudsg.com',
		authUrl : 'https://console.scloudsg.com/uaccount/authentication'
	},
	// 168
	'passport.dellidc.com': {
		root: 'dellidc.com',
		url: 'https://api.dellidc.com',
		default: 'https://console.dellidc.com',
		dws: 'https://dws.dellidc.com',
		whiteList: [ /\.dellidc.com/ ],
		afterLogout : 'https://passport.dellidc.com',
		authUrl : 'https://console.dellidc.com/uaccount/authentication'
	},
	// 169
	'passport.runc.ai': {
		root: 'runc.ai',
		url: 'https://api.runc.ai',
		default: 'https://console.runc.ai',
		dws: 'https://dws.runc.ai',
		whiteList: [ /\.runc.ai/ ],
		afterLogout : 'https://passport.runc.ai',
		authUrl : 'https://console.runc.ai/uaccount/authentication'
	},
	// 170
	'passport.tus-tech.com': {
		root: 'tus-tech.com',
		url: 'https://api.tus-tech.com',
		default: 'https://console.tus-tech.com',
		dws: 'https://dws.tus-tech.com',
		whiteList: [ /\.tus-tech.com/ ],
		afterLogout : 'https://passport.tus-tech.com',
		authUrl : 'https://console.tus-tech.com/uaccount/authentication'
	},
	// 171
	'passport.seashell.vip': {
		root: 'seashell.vip',
		url: 'https://api.seashell.vip',
		default: 'https://console.seashell.vip',
		dws: 'https://dws.seashell.vip',
		whiteList: [ /\.seashell.vip/ ],
		afterLogout : 'https://passport.seashell.vip',
		authUrl : 'https://console.seashell.vip/uaccount/authentication'
	},
	// 172
	'passport.gycloud.com': {
		root: 'gycloud.com',
		url: 'https://api.gycloud.com',
		default: 'https://console.gycloud.com',
		dws: 'https://dws.gycloud.com',
		whiteList: [ /\.gycloud.com/ ],
		afterLogout : 'https://passport.gycloud.com',
		authUrl : 'https://console.gycloud.com/uaccount/authentication'
	},
	// 173
	'passport.godzl.com': {
		root: 'godzl.com',
		url: 'https://api.godzl.com',
		default: 'https://console.godzl.com',
		dws: 'https://dws.godzl.com',
		whiteList: [ /\.godzl.com/ ],
		afterLogout : 'https://passport.godzl.com',
		authUrl : 'https://console.godzl.com/uaccount/authentication'
	},
	// 174
	'passport.feb.sg': {
		root: 'feb.sg',
		url: 'https://api.feb.sg',
		default: 'https://console.feb.sg',
		dws: 'https://dws.feb.sg',
		whiteList: [ /\.feb.sg/ ],
		afterLogout : 'https://passport.feb.sg',
		authUrl : 'https://console.feb.sg/uaccount/authentication'
	},
	// 176
	'passport.idc2.com.cn': {
		root: 'idc2.com.cn',
		url: 'https://api.idc2.com.cn',
		default: 'https://console.idc2.com.cn',
		dws: 'https://dws.idc2.com.cn',
		whiteList: [ /\.idc2.com.cn/ ],
		afterLogout : 'https://passport.idc2.com.cn',
		authUrl : 'https://console.idc2.com.cn/uaccount/authentication'
	},
	// 179
	'passport.cn-uc.sensecore.cn': {
		root: 'cn-uc.sensecore.cn',
		url: 'https://api.cn-uc.sensecore.cn',
		default: 'https://console.cn-uc.sensecore.cn',
		dws: 'https://dws.cn-uc.sensecore.cn',
		whiteList: [ /\.cn-uc.sensecore.cn/ ],
		afterLogout : 'https://passport.cn-uc.sensecore.cn',
		authUrl : 'https://console.cn-uc.sensecore.cn/uaccount/authentication'
	},
	// 180
	'passport.yun.linkscale.cn': {
		root: 'yun.linkscale.cn',
		url: 'https://api.yun.linkscale.cn',
		default: 'https://console.yun.linkscale.cn',
		dws: 'https://dws.yun.linkscale.cn',
		whiteList: [ /\.yun.linkscale.cn/ ],
		afterLogout : 'https://passport.yun.linkscale.cn',
		authUrl : 'https://console.yun.linkscale.cn/uaccount/authentication'
	},
	// 181
	'passport.cloud.linkscale.com': {
		root: 'cloud.linkscale.com',
		url: 'https://api.cloud.linkscale.com',
		default: 'https://console.cloud.linkscale.com',
		dws: 'https://dws.cloud.linkscale.com',
		whiteList: [ /\.cloud.linkscale.com/ ],
		afterLogout : 'https://passport.cloud.linkscale.com',
		authUrl : 'https://console.cloud.linkscale.com/uaccount/authentication'
	},
	// 183
	'passport.cloud.51combo.com': {
		root: 'cloud.51combo.com',
		url: 'https://api.cloud.51combo.com',
		default: 'https://console.cloud.51combo.com',
		dws: 'https://dws.cloud.51combo.com',
		whiteList: [ /\.cloud.51combo.com/ ],
		afterLogout : 'https://passport.cloud.51combo.com',
		authUrl : 'https://console.cloud.51combo.com/uaccount/authentication'
	},
	// 184
	'passport.yuniso.com': {
		root: 'yuniso.com',
		url: 'https://api.yuniso.com',
		default: 'https://console.yuniso.com',
		dws: 'https://dws.yuniso.com',
		whiteList: [ /\.yuniso.com/ ],
		afterLogout : 'https://passport.yuniso.com',
		authUrl : 'https://console.yuniso.com/uaccount/authentication'
	},
	// 185
	'passport.echola.cn': {
		root: 'echola.cn',
		url: 'https://api.echola.cn',
		default: 'https://console.echola.cn',
		dws: 'https://dws.echola.cn',
		whiteList: [ /\.echola.cn/ ],
		afterLogout : 'https://passport.echola.cn',
		authUrl : 'https://console.echola.cn/uaccount/authentication'
	},
	// 189
	'passport.rockbasecloud.com': {
		root: 'rockbasecloud.com',
		url: 'https://api.rockbasecloud.com',
		default: 'https://console.rockbasecloud.com',
		dws: 'https://dws.rockbasecloud.com',
		whiteList: [ /\.rockbasecloud.com/ ],
		afterLogout : 'https://passport.rockbasecloud.com',
		authUrl : 'https://console.rockbasecloud.com/uaccount/authentication'
	},
	// 188
	'passport.cloud.dezai.com': {
		root: 'cloud.dezai.com',
		url: 'https://api.cloud.dezai.com',
		default: 'https://console.cloud.dezai.com',
		dws: 'https://dws.cloud.dezai.com',
		whiteList: [ /\.cloud.dezai.com/ ],
		afterLogout : 'https://passport.cloud.dezai.com',
		authUrl : 'https://console.cloud.dezai.com/uaccount/authentication'
	},
	// 190
	'passport.armadasolutions.net': {
		root: 'armadasolutions.net',
		url: 'https://api.armadasolutions.net',
		default: 'https://console.armadasolutions.net',
		dws: 'https://dws.armadasolutions.net',
		whiteList: [ /\.armadasolutions.net/ ],
		afterLogout : 'https://passport.armadasolutions.net',
		authUrl : 'https://console.armadasolutions.net/uaccount/authentication'
	},
	// 191
	'passport.ziguang.unicloud.com': {
		root: 'ziguang.unicloud.com',
		url: 'https://api.ziguang.unicloud.com',
		default: 'https://console.ziguang.unicloud.com',
		dws: 'https://dws.ziguang.unicloud.com',
		whiteList: [ /\.ziguang.unicloud.com/ ],
		afterLogout : 'https://passport.ziguang.unicloud.com',
		authUrl : 'https://console.ziguang.unicloud.com/uaccount/authentication'
	},
	// 192
	'passport.mingzheng.net.cn': {
		root: 'mingzheng.net.cn',
		url: 'https://api.mingzheng.net.cn',
		default: 'https://console.mingzheng.net.cn',
		dws: 'https://dws.mingzheng.net.cn',
		whiteList: [ /\.mingzheng.net.cn/ ],
		afterLogout : 'https://passport.mingzheng.net.cn',
		authUrl : 'https://console.mingzheng.net.cn/uaccount/authentication'
	},
	// 194
	'passport.starcom.co.id': {
		root: 'starcom.co.id',
		url: 'https://api.starcom.co.id',
		default: 'https://console.starcom.co.id',
		dws: 'https://dws.starcom.co.id',
		whiteList: [ /\.starcom.co.id/ ],
		afterLogout : 'https://passport.starcom.co.id',
		authUrl : 'https://console.starcom.co.id/uaccount/authentication'
	},
	//195
	'passport.tricloud.info': {
		root: 'tricloud.info',
		url: 'https://api.tricloud.info',
		default: 'https://console.tricloud.info',
		dws: 'https://dws.tricloud.info',
		whiteList: [ /\.tricloud.info/ ],
		afterLogout : 'https://passport.tricloud.info',
		authUrl : 'https://console.tricloud.info/uaccount/authentication'
	},
	//196
	'passport.sat.net.id': {
		root: 'sat.net.id',
		url: 'https://api.sat.net.id',
		default: 'https://console.sat.net.id',
		dws: 'https://dws.sat.net.id',
		whiteList: [ /\.sat.net.id/ ],
		afterLogout : 'https://passport.sat.net.id',
		authUrl : 'https://console.sat.net.id/uaccount/authentication'
	},
	//197
	'passport.ckcloudai.com': {
		root: 'ckcloudai.com',
		url: 'https://api.ckcloudai.com',
		default: 'https://console.ckcloudai.com',
		dws: 'https://dws.ckcloudai.com',
		whiteList: [ /\.ckcloudai.com/ ],
		afterLogout : 'https://passport.ckcloudai.com',
		authUrl : 'https://console.ckcloudai.com/uaccount/authentication'
	},
	//198
	'passport.zhixinyunsuan.com': {
		root: 'zhixinyunsuan.com',
		url: 'https://api.zhixinyunsuan.com',
		default: 'https://console.zhixinyunsuan.com',
		dws: 'https://dws.zhixinyunsuan.com',
		whiteList: [ /\.zhixinyunsuan.com/ ],
		afterLogout : 'https://passport.zhixinyunsuan.com',
		authUrl : 'https://console.zhixinyunsuan.com/uaccount/authentication'
	},
	//199
	'passport.cloud.fkw.com': {
		root: 'cloud.fkw.com',
		url: 'https://api.cloud.fkw.com',
		default: 'https://console.cloud.fkw.com',
		dws: 'https://dws.cloud.fkw.com',
		whiteList: [ /\.cloud.fkw.com/ ],
		afterLogout : 'https://passport.cloud.fkw.com',
		authUrl : 'https://console.cloud.fkw.com/uaccount/authentication'
	},
	'passport.shcu-cloud.cn': {
		root: 'shcu-cloud.cn',
		url: 'https://api.shcu-cloud.cn',
		default: 'https://console.shcu-cloud.cn',
		dws: 'https://dws.shcu-cloud.cn',
		whiteList: [ /\.shcu-cloud.cn/ ],
		afterLogout : 'https://passport.shcu-cloud.cn',
		authUrl : 'https://console.shcu-cloud.cn/uaccount/authentication'
	},
	'passport.yuyi-ai.cn': {
		root: 'yuyi-ai.cn',
		url: 'https://api.yuyi-ai.cn',
		default: 'https://console.yuyi-ai.cn',
		dws: 'https://dws.yuyi-ai.cn',
		whiteList: [ /\.yuyi-ai.cn/ ],
		afterLogout : 'https://passport.yuyi-ai.cn',
		authUrl : 'https://console.yuyi-ai.cn/uaccount/authentication'
	},
	'passport.vicloud.vn': {
		root: 'vicloud.vn',
		url: 'https://api.vicloud.vn',
		default: 'https://console.vicloud.vn',
		dws: 'https://dws.vicloud.vn',
		whiteList: [ /\.vicloud.vn/ ],
		afterLogout : 'https://passport.vicloud.vn',
		authUrl : 'https://console.vicloud.vn/uaccount/authentication'
	},

	'passport.bj-xclh.com': {
		root: 'bj-xclh.com',
		url: 'https://api.bj-xclh.com',
		default: 'https://console.bj-xclh.com',
		dws: 'https://dws.bj-xclh.com',
		whiteList: [ /\.bj-xclh.com/ ],
		afterLogout: 'https://passport.bj-xclh.com',
		authUrl: 'https://console.bj-xclh.com/uaccount/authentication'
	},

	'passport.netnam.vn': {
	    root: 'netnam.vn',
	    url: 'https://api-netcloudx.netnam.vn',
	    default: 'https://console-netcloudx.netnam.vn',
	    dws: 'https://dws.netnam.vn',
	    whiteList: [ /\.netnam.vn/ ],
	    afterLogout: 'https://passport.netnam.vn',
	    authUrl: 'https://console-netcloudx.netnam.vn/uaccount/authentication'
	}
,
	'passport.cloud.vnpt.vn': {
	    root: 'cloud.vnpt.vn',
	    url: 'https://api-services.cloud.vnpt.vn',
	    default: 'https://services.cloud.vnpt.vn',
	    dws: 'https://dws.cloud.vnpt.vn',
	    whiteList: [ /\.cloud.vnpt.vn/ ],
	    afterLogout: 'https://passport.cloud.vnpt.vn',
	    authUrl: 'https://services.cloud.vnpt.vn/uaccount/authentication'
	}
,
	'passport.sccloud.org': {
	    root: 'sccloud.org',
	    url: 'https://api.sccloud.org',
	    default: 'https://console.sccloud.org',
	    dws: 'https://dws.sccloud.org',
	    whiteList: [ /\.sccloud.org/ ],
	    afterLogout: 'https://passport.sccloud.org',
	    authUrl: 'https://console.sccloud.org/uaccount/authentication'
	}
}

var domain = document.location.hostname
for (var key in url_config) {
	if (domain.match(key)) {
		urls = url_config[key]
	}
}

// 仅测试环境把接口发到当前页面，由测试容器里的 nginx 转发到 api.compshare.cn。
// 线上直接请求正式接口，后续走统一转发，不在这里转发。
if (domain === 'passport.prj-ucompshare-test.svc.c3.u4') {
	urls = {};
	for (var configKey in url_config['passport.compshare.cn']) {
		urls[configKey] = url_config['passport.compshare.cn'][configKey];
	}
	if (document.location.protocol && document.location.host) {
		urls.url = document.location.protocol + '//' + document.location.host;
	}
}
if (
	domain === 'passport.prj-ucompshare-prod.svc.c1.u4' ||
	domain === 'localhost' ||
	domain === '127.0.0.1'
) {
	urls = url_config['passport.compshare.cn']
}

if(!urls){
    urls = url_config['ucloud.cn'];
	// 本地测试预发接口
	urls =  url_config['passport-test03.ucloudadmin.com']
}

module.exports = urls



// WEBPACK FOOTER //
// ./src/config/config.js